import { render, staticRenderFns } from "./position-type.vue?vue&type=template&id=77ff661a&scoped=true&"
import script from "./position-type.vue?vue&type=script&lang=js&"
export * from "./position-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff661a",
  null
  
)

export default component.exports